module.exports = __webpack_public_path__ + "img/1594292209.803326ff.jpg";